import { useEffect, useState } from 'react';
import { API_BASE } from '../client/config';
import { setContentGroup } from '../client/groupScope';
import type { DeviceGroup, GroupActor } from '../store/deviceGroups';

export function GroupWorkContext(): JSX.Element | null {
  const [data, setData] = useState<{ groups: DeviceGroup[]; actor: GroupActor } | null>(null);
  const [selected, setSelected] = useState('');
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const response = await fetch(`${API_BASE}/api/device-groups`, { credentials: 'include' });
        if (!response.ok) throw new Error('담당 그룹을 불러오지 못했습니다.');
        const next = await response.json() as { groups: DeviceGroup[]; actor: GroupActor };
        if (!alive) return;
        const key = `bricklit:work-group:${next.actor.orgId}`;
        const saved = sessionStorage.getItem(key);
        // 새 콘텐츠의 기본 소유 그룹(x-content-group)은 쓸 수 있는 그룹이어야 한다(SCDS-97). 목록에는 조회만
        // 하는 그룹도 섞여 오는데, 그런 그룹이 이름순으로 앞서면 그 그룹으로 만들려다 서버가
        // 'content write permission required'로 막았다.
        const writable = (id: string) => next.actor.central
          || next.actor.groups.some(g => g.groupId === id && ['Admin', 'Editor'].includes(g.role));
        const groupId = saved && next.groups.some(g => g.id === saved && writable(g.id)) ? saved
          : next.actor.central ? '' : next.groups.find(g => writable(g.id))?.id ?? '';
        setData(next); setSelected(groupId); setError(null);
        setContentGroup(next.actor.enforced ? groupId || (next.actor.central ? null : undefined) : undefined);
      } catch (cause) { if (alive) { setError(cause instanceof Error ? cause.message : '그룹 조회 오류'); setContentGroup(undefined); } }
    };
    void load(); window.addEventListener('bricklit:scope-changed', load);
    return () => { alive = false; setContentGroup(undefined); window.removeEventListener('bricklit:scope-changed', load); };
  }, []);
  // 2026-09-14: 상단 '새 콘텐츠 소유 그룹' 바는 표시하지 않는다(콘텐츠 소유 범위 UI 제거 결정 O-2).
  // 기본 소유 그룹(공통 / 담당 첫 그룹)은 위 effect가 조용히 정한다. 콘텐츠별 공개 범위는
  // 각 콘텐츠의 수정 모달(공개 범위, Owner만)에서 바꾼다(2026-09-15).
  void data; void selected; void setSelected; void error;
  return null;
}
